<template>
    <div>
      <el-card class="box-card">
               <p>中运交投</p>
               <div class="mo"><span>账户余额</span>  ￥0.00</div>
               <h3>请使用同名银行卡号通过网银进行充值(收款账号如下):</h3>
               <ul>
                 <li><span >开户户名  </span> <span>上海******公司</span></li>
                 <li><span>账号  </span> <span> 23300012345</span></li>
                 <li><span>开户支行   </span> <span>连连银通-备付金账户 </span></li>
                 <li><span>开户银行（行别）   </span> <span class="zf">支付机构备付金集中存管账户（或者“其它991”） </span></li>
                 <li><span>开户行号   </span> <span>991331000295 </span></li>
                 <li>省：浙江省 市：杭州市</li>
               </ul>
               <div class="card-btn">
                  <button @click="$emit('fsisshroff',false)">取消</button> 
                  <button @click="skip()">借款信息录入</button>
                  <button @click="topup()">
                      已完成充值
                  </button>
               </div>
  
          </el-card>
    </div>
  </template>
  
  <script>
  export default {
     data(){
      return {
          timepiece:10,
          time:null
      }
     },
     props:['fsisshroff'],
     
     created(){
  
    
     },
     methods:{
        topup(){
            this.$emit('fsisshroff',true)
            this.skip(1)
        },
        skip(r){
            this.$router.push({
                path:'/loan-tcustbase',
                query:{id:this.$store.state.info,url:'首页'}
            })
            this.$bus.$emit('aaa')
        }
  
      
      
     }
  }
  </script>
  
  <style lang="scss">
  .box-card{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 500px;
      height: 380px;
      text-align: center;
      .p2{
          margin: 20px 0;
      }
      .footer-btn{
          height: 50px;
          width: 100%;
          display: flex;
          margin: 60px 0;
          justify-content: space-around;
          }
      p:nth-child(2){
          margin: 130px 0;
          span{
              color: blue;
          }
          
      }
    ul{
        width: 100%;
        margin: 30px 0;
        padding-left:70px ;
        
        li{
            width: 100%;
            text-align: left;
            margin: 5px 0;
            span:nth-child(1){
                width: 100px !important;
            }
            span{
                font-size: 12px;
                display: inline-block;
                text-align: left;
            }
            
        }
    }
  }
  .card-btn{
      display: flex;
      width: 82%;
      margin: 0 auto;
      justify-content: space-between;
      button{
          border: none;
          background: #3B46C4;
          width: 90px;
          height: 40px;
          border-radius: 4px;
          font-weight: 900;
          color: #fff;
      }
  }
  
  .mo{
      width: 200px;
      margin: 20px auto;
      height: 35px;
      line-height: 35px;
      background: #E9EAFA;
      border-radius: 4px;
      color: #3D4090;
      >span{
        background: #E9EAFA;
      }
    }
  </style>